const formDataValues = {
  dataEstadoCivil: '',
  dataContacto: '',
  dataDireccion: '',
  dataUrbanizacion: '',
  dataDepartamento: '',
  dataProvincia: '',
  dataDistrito: '',
  dataReferencia: '',
  dataResponsable: ''
};

const formFamilyValues = {
  fullNameFather: '',
  dniFather: '',
  phoneFather: '',
  fullNameMother: '',
  dniMother: '',
  phoneMother: '',
  fullNameRepresentative: '',
  dniRepresentative: '',
  phoneRepresentative: '',
  numberBrothers: '',
  familySituation: '',
  nameSpouse: '',
  dniSpouse: '',
  phoneSpouse: '',
  numberChildrenSpouse: '',
  responsibleWorkSituation: '',
  nroHermanos: '',
  dependents: '',
  relationshipFamiliar1: '',
  relationshipFamiliar2: '',
  fullNameOtherFamiliar: '',
  dniOtherFamiliar: '',
  phoneOtherFamiliar: '',
  nameFamiliar1: '',
  dniFamiliar1: '',
  phoneFamiliar1: '',
  nameFamiliar2: '',
  dniFamiliar2: '',
  phoneFamiliar2: ''
};

const formIncomeValues = {
  incomeDelEstudiante: '',
  incomeDePadre: '',
  incomeDeMadre: '',
  incomeDeApoderado: '',
  incomeDeOtroFamiliar: '',
  incomeDeConyugue: '',
  incomeRentas: '',
  incomeRemesas: '',
  incomeOtros: ''
};

const formExpensesValues = {
  expensesAlquilerHipoteca: '',
  expensesLuz: '',
  expensesAgua: '',
  expensesTelefonoFijo: '',
  expensesTelefonoCelular: '',
  expensesCable: '',
  expensesInternet: '',
  expensesGas: '',
  expensesAlimentacion: '',
  expensesMovilidad: '',
  expensesSalud: '',
  expensesPensionUTP: '',
  expensesPensionEstudiosOtrosFam: '',
  expensesArticulosAseo: '',
  expensesVestuarioCalzado: '',
  expensesPeriodicos: '',
  expensesDeudas: '',
  expensesOtros: ''
};

const formSavingsAndDebts = {
  savingsPosee: '',
  savingsEntidad: '',
  savingsMonto: '',
  debtsPosee: '',
  debtsTipo: '',
  debtsEntidad: '',
  debtsMonto: '',
  debtsPagoMensual: '',
  debtsFechaFin: ''
};

const formAdditionalInformationValues = {
  additionalInformation: ''
};

const formHealthValues = {
  healthDiagnosis: '',
  healthDiagnosisDetail: '',
  healthPertenencia: '',
  healthEstado: '',
  healthLaboral: ''
};

const formLivingPlaceValues = {
  livingPlacePertenencia: '',
  livingPlaceEstado: '',
  livingPlaceDistribucion: ''
};

const formBse = [
  {
    id: '1',
    description: 'Estado Civil',
    value: ''
  },
  {
    id: '2',
    description: 'Teléfono',
    value: ''
  },
  {
    id: '3',
    description: 'Dirección',
    value: ''
  },
  {
    id: '4',
    description: 'Urbanización',
    value: ''
  },
  {
    id: '5',
    description: 'Departamento',
    value: ''
  },
  {
    id: '6',
    description: 'Provincia',
    value: ''
  },
  {
    id: '7',
    description: 'Distrito',
    value: ''
  },
  {
    id: '8',
    description: 'Referencia',
    value: ''
  },
  {
    id: '10',
    description:
      'Persona (s) responsable(s) economicamente del hogar y de los pagos de la universidad',
    value: ''
  },
  {
    id: '11',
    description: 'Nombre Completo del Padre',
    value: ''
  },
  {
    id: '12',
    description: 'DNI de Padre',
    value: ''
  },
  {
    id: '13',
    description: 'Teléfono',
    value: ''
  },
  {
    id: '14',
    description: 'Nombre Completo de Madre',
    value: ''
  },
  {
    id: '15',
    description: 'DNI de Madre',
    value: ''
  },
  {
    id: '16',
    description: 'Teléfono',
    value: ''
  },
  {
    id: '17',
    description: 'Nombre Completo del Apoderado',
    value: ''
  },
  {
    id: '18',
    description: 'DNI de Apoderado',
    value: ''
  },
  {
    id: '19',
    description: 'Teléfono',
    value: ''
  },
  {
    id: '20',
    description: 'Numero de Hermanos',
    value: ''
  },
  {
    id: '21',
    description: 'Situacion Familiar',
    value: ''
  },
  {
    id: '22',
    description: 'Nombre completo de Cónyuge',
    value: ''
  },
  {
    id: '23',
    description: 'DNI de Cónyuge',
    value: ''
  },
  {
    id: '24',
    description: 'Teléfono',
    value: ''
  },
  {
    id: '25',
    description: 'Numero de Hijos',
    value: ''
  },
  {
    id: '26',
    description: 'Situacion laboral',
    value: ''
  },
  {
    id: '27',
    description: 'Ingreso Alumno',
    value: ''
  },
  {
    id: '28',
    description: 'Ingreso Padre',
    value: ''
  },
  {
    id: '29',
    description: 'Ingreso Madre',
    value: ''
  },
  {
    id: '30',
    description: 'Ingreso Apoderado',
    value: ''
  },
  {
    id: '31',
    description: 'Ingreso otro familiar',
    value: ''
  },
  {
    id: '32',
    description: 'Ingreso Pareja',
    value: ''
  },
  {
    id: '33',
    description: 'Rentas y Alquileres',
    value: ''
  },
  {
    id: '34',
    description: 'Remesas',
    value: ''
  },
  {
    id: '35',
    description: 'Otros',
    value: ''
  },
  {
    id: '36',
    description: 'Alquiler o Hipoteca de vivienda ',
    value: ''
  },
  {
    id: '37',
    description: 'Luz',
    value: ''
  },
  {
    id: '38',
    description: 'Agua',
    value: ''
  },
  {
    id: '39',
    description: 'Teléfono Fijo',
    value: ''
  },
  {
    id: '40',
    description: 'Telefono celular',
    value: ''
  },
  {
    id: '41',
    description: 'Cable',
    value: ''
  },
  {
    id: '42',
    description: 'Internet',
    value: ''
  },
  {
    id: '43',
    description: 'Gas',
    value: ''
  },
  {
    id: '44',
    description: 'Alimentación',
    value: ''
  },
  {
    id: '45',
    description: 'Movilidad general',
    value: ''
  },
  {
    id: '46',
    description: 'Salud - Gastos de seguro, medicinas etc',
    value: ''
  },
  {
    id: '47',
    description: 'Pensión UTP',
    value: ''
  },
  {
    id: '48',
    description: 'Pensión de Otros Familiares',
    value: ''
  },
  {
    id: '49',
    description: 'Material de estudios (gasto mensual)',
    value: ''
  },
  {
    id: '50',
    description: 'Artículos aseo',
    value: ''
  },
  {
    id: '51',
    description: 'Vestido y calzado (gasto mensual)',
    value: ''
  },
  {
    id: '52',
    description: 'Periódicos y revistas',
    value: ''
  },
  {
    id: '53',
    description: 'Deuda 1',
    value: ''
  },
  {
    id: '54',
    description: 'Deuda 2',
    value: ''
  },
  {
    id: '55',
    description: 'Otros 1(especificar)',
    value: ''
  },
  {
    id: '56',
    description: 'Ahorros',
    value: ''
  },
  {
    id: '57',
    description: 'Entidad',
    value: ''
  },
  {
    id: '58',
    description: 'Monto',
    value: ''
  },
  {
    id: '59',
    description: 'Deudas',
    value: ''
  },
  {
    id: '60',
    description: 'Tipo de Deuda',
    value: ''
  },
  {
    id: '61',
    description: 'Entidad',
    value: ''
  },
  {
    id: '62',
    description: 'Monto de la Deuda',
    value: ''
  },
  {
    id: '63',
    description: 'Pago Mensual',
    value: ''
  },
  {
    id: '64',
    description: 'Término de cancelación de Deuda',
    value: ''
  },
  {
    id: '65',
    description: 'Pertenencia de vivienda',
    value: ''
  },
  {
    id: '66',
    description: 'Estado de construccion de la vivienda',
    value: ''
  },
  {
    id: '67',
    description: 'Miembros de la familia por habitación',
    value: ''
  },
  {
    id: '68',
    description:
      'Cuenta con algún Diagnóstico que genera tratamiento continúo de salud',
    value: ''
  },
  {
    id: '69',
    description: 'Diagnostico',
    value: ''
  },
  {
    id: '70',
    description: 'Salud',
    value: ''
  },
  {
    id: '71',
    description: 'Situación de salud actual por COVID',
    value: ''
  },
  {
    id: '72',
    description: 'Situación laboral actual por COVID',
    value: ''
  },
  {
    id: '73',
    description: 'Información Adicional',
    value: ''
  },
  {
    id: '74',
    description: 'Con quien vive el estudiante',
    value: ''
  },
  {
    id: '75',
    description:
      'Persona (s) responsable(s) economicamente del hogar y de los pagos de la universidad',
    value: ''
  },
  {
    id: '77',
    description: 'Situación Familiar',
    value: ''
  },
  {
    id: '78',
    description:
      'Cuál es la situación laboral actual del responsable de los pagos de la universidad',
    value: ''
  },
  {
    id: '79',
    description: 'Pertenencia de vivienda',
    value: ''
  },
  {
    id: '80',
    description: 'Pertenencia de salud',
    value: ''
  },
  {
    id: '81',
    description: 'Nombre Completo de otro familiar',
    value: ''
  },
  {
    id: '82',
    description: 'DNI de otro familiar',
    value: ''
  },
  {
    id: '83',
    description: 'Teléfono de otro familiar',
    value: ''
  }
];

const formatValuesSave = (
  data: any = {
    ...formDataValues,
    ...formIncomeValues,
    ...formExpensesValues,
    ...formSavingsAndDebts,
    ...formAdditionalInformationValues,
    ...formLivingPlaceValues,
    ...formFamilyValues,
    ...formHealthValues
  }
) => {
  if (data.relationshipFamiliar1 === 'Padre') {
    data.fullNameFather = data.nameFamiliar1;
    data.dniFather = data.dniFamiliar1;
    data.phoneFather = data.phoneFamiliar1;
  }

  if (
    data.relationshipFamiliar2 === 'Padre' &&
    data.relationshipFamiliar1 !== 'Padre'
  ) {
    data.fullNameFather = data.nameFamiliar2;
    data.dniFather = data.dniFamiliar2;
    data.phoneFather = data.phoneFamiliar2;
  }

  if (data.relationshipFamiliar1 === 'Madre') {
    data.fullNameMother = data.nameFamiliar1;
    data.dniMother = data.dniFamiliar1;
    data.phoneMother = data.phoneFamiliar1;
  }

  if (
    data.relationshipFamiliar2 === 'Madre' &&
    data.relationshipFamiliar1 !== 'Madre'
  ) {
    data.fullNameMother = data.nameFamiliar2;
    data.dniMother = data.dniFamiliar2;
    data.phoneMother = data.phoneFamiliar2;
  }

  if (data.relationshipFamiliar1 === 'Apoderado') {
    data.fullNameRepresentative = data.nameFamiliar1;
    data.dniRepresentative = data.dniFamiliar1;
    data.phoneRepresentative = data.phoneFamiliar1;
  }

  if (
    data.relationshipFamiliar2 === 'Apoderado' &&
    data.relationshipFamiliar1 !== 'Apoderado'
  ) {
    data.fullNameRepresentative = data.nameFamiliar2;
    data.dniRepresentative = data.dniFamiliar2;
    data.phoneRepresentative = data.phoneFamiliar2;
  }

  if (data.relationshipFamiliar1 === 'Conyugue') {
    data.nameSpouse = data.nameFamiliar1;
    data.dniSpouse = data.dniFamiliar1;
    data.phoneSpouse = data.phoneFamiliar1;
  }

  if (
    data.relationshipFamiliar2 === 'Conyugue' &&
    data.relationshipFamiliar1 !== 'Conyugue'
  ) {
    data.nameSpouse = data.nameFamiliar2;
    data.dniSpouse = data.dniFamiliar2;
    data.phoneSpouse = data.phoneFamiliar2;
  }

  if (data.relationshipFamiliar1 === 'Otro familiar directo') {
    data.fullNameOtherFamiliar = data.nameFamiliar1;
    data.dniOtherFamiliar = data.dniFamiliar1;
    data.phoneOtherFamiliar = data.phoneFamiliar1;
  }

  if (
    data.relationshipFamiliar2 === 'Otro familiar directo' &&
    data.relationshipFamiliar1 !== 'Otro familiar directo'
  ) {
    data.fullNameOtherFamiliar = data.nameFamiliar2;
    data.dniOtherFamiliar = data.dniFamiliar2;
    data.phoneOtherFamiliar = data.phoneFamiliar2;
  }

  const valueMap: any = {
    1: 'dataEstadoCivil',
    2: 'dataContacto',
    3: 'dataDireccion',
    4: 'dataUrbanizacion',
    5: 'dataDepartamento',
    6: 'dataProvincia',
    7: 'dataDistrito',
    8: 'dataReferencia',
    75: 'dataResponsable',
    11: 'fullNameFather',
    12: 'dniFather',
    13: 'phoneFather',
    14: 'fullNameMother',
    15: 'dniMother',
    16: 'phoneMother',
    17: 'fullNameRepresentative',
    18: 'dniRepresentative',
    19: 'phoneRepresentative',
    20: 'numberBrothers',
    77: 'familySituation',
    22: 'nameSpouse',
    23: 'dniSpouse',
    24: 'phoneSpouse',
    25: 'numberChildrenSpouse',
    78: 'responsibleWorkSituation',
    27: 'incomeDelEstudiante',
    28: 'incomeDePadre',
    29: 'incomeDeMadre',
    30: 'incomeDeApoderado',
    31: 'incomeDeOtroFamiliar',
    32: 'incomeDeConyugue',
    33: 'incomeRentas',
    34: 'incomeRemesas',
    35: 'incomeOtros',
    36: 'expensesAlquilerHipoteca',
    37: 'expensesLuz',
    38: 'expensesAgua',
    39: 'expensesTelefonoFijo',
    40: 'expensesTelefonoCelular',
    41: 'expensesCable',
    42: 'expensesInternet',
    43: 'expensesGas',
    44: 'expensesAlimentacion',
    45: 'expensesMovilidad',
    46: 'expensesSalud',
    47: 'expensesPensionUTP',
    48: 'expensesPensionEstudiosOtrosFam',
    50: 'expensesArticulosAseo',
    51: 'expensesVestuarioCalzado',
    52: 'expensesPeriodicos',
    53: 'expensesDeudas',
    55: 'expensesOtros',
    56: 'savingsPosee',
    57: 'savingsEntidad',
    58: 'savingsMonto',
    59: 'debtsPosee',
    60: 'debtsTipo',
    61: 'debtsEntidad',
    62: 'debtsMonto',
    63: 'debtsPagoMensual',
    64: 'debtsFechaFin',
    73: 'additionalInformation',
    79: 'livingPlacePertenencia',
    66: 'livingPlaceEstado',
    67: 'livingPlaceDistribucion',
    68: 'healthDiagnosis',
    69: 'healthDiagnosisDetail',
    80: 'healthPertenencia',
    71: 'healthEstado',
    72: 'healthLaboral',
    74: 'dependents',
    81: 'fullNameOtherFamiliar',
    82: 'dniOtherFamiliar',
    83: 'phoneOtherFamiliar'
  };

  formBse.forEach((f) => {
    if (valueMap[f.id]) {
      f.value = data[valueMap[f.id]];
    }
  });
  return formBse;
};

const findField = (arr: any[], value: string) =>
  arr.find((f) => f.id === value)?.value;

const formatValuesLoad = (data = formBse) => {
  const fullNameFather = findField(data, '11');
  const dniFather = findField(data, '12');
  const phoneFather = findField(data, '13');
  const fullNameMother = findField(data, '14');
  const dniMother = findField(data, '15');
  const phoneMother = findField(data, '16');
  const fullNameRepresentative = findField(data, '17');
  const dniRepresentative = findField(data, '18');
  const phoneRepresentative = findField(data, '19');
  const nameSpouse = findField(data, '22');
  const dniSpouse = findField(data, '23');
  const phoneSpouse = findField(data, '24');
  const fullNameOtherFamiliar = findField(data, '81');
  const dniOtherFamiliar = findField(data, '82');
  const phoneOtherFamiliar = findField(data, '83');

  // Declarar variables para familiares
  let nameFamiliar1 = '';
  let dniFamiliar1 = '';
  let phoneFamiliar1 = '';
  let relationshipFamiliar1 = '';
  let nameFamiliar2 = '';
  let dniFamiliar2 = '';
  let phoneFamiliar2 = '';
  let relationshipFamiliar2 = '';

  if (fullNameFather) {
    nameFamiliar1 = fullNameFather;
    dniFamiliar1 = dniFather;
    phoneFamiliar1 = phoneFather;
    relationshipFamiliar1 = 'Padre';
  } else if (fullNameMother) {
    nameFamiliar1 = fullNameMother;
    dniFamiliar1 = dniMother;
    phoneFamiliar1 = phoneMother;
    relationshipFamiliar1 = 'Madre';
  } else if (fullNameRepresentative) {
    nameFamiliar1 = fullNameRepresentative;
    dniFamiliar1 = dniRepresentative;
    phoneFamiliar1 = phoneRepresentative;
    relationshipFamiliar1 = 'Apoderado';
  } else if (nameSpouse) {
    nameFamiliar1 = nameSpouse;
    dniFamiliar1 = dniSpouse;
    phoneFamiliar1 = phoneSpouse;
    relationshipFamiliar1 = 'Conyugue';
  } else if (fullNameOtherFamiliar) {
    nameFamiliar1 = fullNameOtherFamiliar;
    dniFamiliar1 = dniOtherFamiliar;
    phoneFamiliar1 = phoneOtherFamiliar;
    relationshipFamiliar1 = 'Otro familiar directo';
  }

  // Comprobar si hay información adicional de familiares disponible para el familiar2
  if (fullNameFather && fullNameFather !== nameFamiliar1) {
    nameFamiliar2 = fullNameFather;
    dniFamiliar2 = dniFather;
    phoneFamiliar2 = phoneFather;
    relationshipFamiliar2 = 'Padre';
  } else if (fullNameMother && fullNameMother !== nameFamiliar1) {
    nameFamiliar2 = fullNameMother;
    dniFamiliar2 = dniMother;
    phoneFamiliar2 = phoneMother;
    relationshipFamiliar2 = 'Madre';
  } else if (
    fullNameRepresentative &&
    fullNameRepresentative !== nameFamiliar1
  ) {
    nameFamiliar2 = fullNameRepresentative;
    dniFamiliar2 = dniRepresentative;
    phoneFamiliar2 = phoneRepresentative;
    relationshipFamiliar2 = 'Apoderado';
  } else if (nameSpouse && nameSpouse !== nameFamiliar1) {
    nameFamiliar2 = nameSpouse;
    dniFamiliar2 = dniSpouse;
    phoneFamiliar2 = phoneSpouse;
    relationshipFamiliar2 = 'Conyugue';
  } else if (fullNameOtherFamiliar && fullNameOtherFamiliar !== nameFamiliar1) {
    nameFamiliar2 = fullNameOtherFamiliar;
    dniFamiliar2 = dniOtherFamiliar;
    phoneFamiliar2 = phoneOtherFamiliar;
    relationshipFamiliar2 = 'Otro familiar directo';
  }

  return {
    formData: {
      dataEstadoCivil: findField(data, '1'),
      dataContacto: findField(data, '2'),
      dataDireccion: findField(data, '3'),
      dataUrbanizacion: findField(data, '4'),
      dataDepartamento: findField(data, '5'),
      dataProvincia: findField(data, '6'),
      dataDistrito: findField(data, '7'),
      dataReferencia: findField(data, '8')
    },
    formFamily: {
      dataResponsable: findField(data, '75'),
      familySituation: findField(data, '77'),
      dependents: findField(data, '74'),
      responsibleWorkSituation: findField(data, '78'),
      nameFamiliar1,
      dniFamiliar1,
      phoneFamiliar1,
      nameFamiliar2,
      dniFamiliar2,
      phoneFamiliar2,
      relationshipFamiliar1,
      relationshipFamiliar2
    },
    formIncome: {
      incomeDelEstudiante: findField(data, '27'),
      incomeDePadre: findField(data, '28'),
      incomeDeMadre: findField(data, '29'),
      incomeDeApoderado: findField(data, '30'),
      incomeDeOtroFamiliar: findField(data, '31'),
      incomeDeConyugue: findField(data, '32'),
      incomeRentas: findField(data, '33'),
      incomeRemesas: findField(data, '34'),
      incomeOtros: findField(data, '35')
    },
    formExpenses: {
      expensesAlquilerHipoteca: findField(data, '36'),
      expensesLuz: findField(data, '37'),
      expensesAgua: findField(data, '38'),
      expensesTelefonoFijo: findField(data, '39'),
      expensesTelefonoCelular: findField(data, '40'),
      expensesCable: findField(data, '41'),
      expensesInternet: findField(data, '42'),
      expensesGas: findField(data, '43'),
      expensesAlimentacion: findField(data, '44'),
      expensesMovilidad: findField(data, '45'),
      expensesSalud: findField(data, '46'),
      expensesPensionUTP: findField(data, '47'),
      expensesPensionEstudiosOtrosFam: findField(data, '48'),
      expensesArticulosAseo: findField(data, '50'),
      expensesVestuarioCalzado: findField(data, '51'),
      expensesPeriodicos: findField(data, '52'),
      expensesDeudas: findField(data, '53'),
      expensesOtros: findField(data, '55')
    },
    formSavingsAndDebts: {
      savingsPosee: findField(data, '56'),
      savingsEntidad: findField(data, '57'),
      savingsMonto: findField(data, '58'),
      debtsPosee: findField(data, '59'),
      debtsTipo: findField(data, '60'),
      debtsEntidad: findField(data, '61'),
      debtsMonto: findField(data, '62'),
      debtsPagoMensual: findField(data, '63'),
      debtsFechaFin: findField(data, '64')
    },
    formLivingPlace: {
      livingPlacePertenencia: findField(data, '79'),
      livingPlaceEstado: findField(data, '66')
    },
    formHealth: {
      healthDiagnosis: findField(data, '68'),
      healthDiagnosisDetail: findField(data, '69'),
      healthPertenencia: findField(data, '80')
    },
    formAdditionalInformation: {
      additionalInformation: findField(data, '73')
    }
  };
};

export {
  formBse, // solo para pruebas
  formDataValues,
  formIncomeValues,
  formExpensesValues,
  formSavingsAndDebts,
  formAdditionalInformationValues,
  formHealthValues,
  formLivingPlaceValues,
  formatValuesSave,
  formatValuesLoad
};
